import type { Language } from "../../types/i18n";
import { cardEmergencyStrings } from "./healthMore/cardEmergency";
import { medicationsStrings } from "./healthMore/medications";
import { recordsStrings } from "./healthMore/records";
import { visitsStrings } from "./healthMore/visits";
import { vitalsStrings } from "./healthMore/vitals";

/*
 * UI strings for one area of the app, merged into `translations` (see
 * ./index.ts) so components read them through `useI18nStore().t` like every
 * other key. English is the reference; the other languages must carry the
 * same keys, which the record type enforces.
 *
 * The area is large, so its keys live in parts under ./healthMore/, each with
 * its own key prefixes; this file only joins them.
 */
const parts = [
  recordsStrings,
  vitalsStrings,
  visitsStrings,
  medicationsStrings,
  cardEmergencyStrings,
] as const;

const join = (language: Language) =>
  Object.assign({}, ...parts.map((p) => p[language])) as typeof en;

const en = {
  ...recordsStrings.en,
  ...vitalsStrings.en,
  ...visitsStrings.en,
  ...medicationsStrings.en,
  ...cardEmergencyStrings.en,
};

export type HealthMoreStrings = typeof en;

export const healthMoreStrings: Record<Language, HealthMoreStrings> = {
  en,
  de: join("de"),
  fr: join("fr"),
  es: join("es"),
  pt: join("pt"),
};
